import { normalize53 } from './layout-53.js';
/**
 * Bumped whenever the same input maps to a different sheet (rule 7): 2 at stage s4 (NPCs map to
 * stat blocks; a character's sheet carries the frozen `effects` and items' `ddbId`).
 */
export const FOUNDRY_MAPPER_VERSION = 2;
export const RESERVED_LAYOUTS = Object.freeze(['6.x']);
const mapper = (layout, normalize) => Object.freeze({ key: `dnd5e@${layout}`, systemId: 'dnd5e', layout, normalize });
export const FOUNDRY_MAPPERS = Object.freeze({
    'dnd5e@5.0-5.2': mapper('5.0-5.2', (actor) => actor),
    'dnd5e@5.3': mapper('5.3', normalize53),
});
export function mapperFor(key) {
    if (RESERVED_LAYOUTS.includes(key.layout))
        return { reserved: true };
    const name = `${key.systemId}@${key.layout}`;
    return Object.hasOwn(FOUNDRY_MAPPERS, name) ? (FOUNDRY_MAPPERS[name] ?? null) : null;
}
/** The mapper a preview uses for a layout no mapper serves: 6.x reads as 5.3, anything else as 5.0–5.2. */
export function nearestMapper(layout) {
    const found = mapperFor({ systemId: 'dnd5e', layout: layout === '6.x' ? '5.3' : layout });
    return found !== null && 'key' in found
        ? found
        : FOUNDRY_MAPPERS['dnd5e@5.0-5.2'];
}
//# sourceMappingURL=registry.js.map